// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { SignupApi } from '../types/signup.types';
import { signupHttpApi } from './signup.api';
import { signupMockApi } from './signup.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const signupApi: SignupApi = useMock ? signupMockApi : signupHttpApi;
